// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"9a05f9de","380":"669f4eb7","437":"91e438ba","453":"b431bd2b","822":"68e7ec2d","862":"76c11b6d","978":"596e1673"}[chunkId] + ".chunk.js";
};